import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContainerComponent } from './container/container.component';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import { InternetExplorerComponent } from './core/components/internet-explorer/internet-explorer.component';
import { IEGuard } from './core/guards/ie.guard';
import { LanguageGuard } from './core/guards/language.guard';
import { MobileGuard } from './core/guards/mobile.guard';
import { PaymentGuard } from './core/guards/payment.guard';
import { SharedSessionGuard } from './core/guards/shared-session.guard';
import { UnauthorizedGuard } from './core/guards/unauthorized.guard';
import { ProjectResolver } from './core/services/project.resolver';
import { SharedProjectResolver } from './core/services/shared-project.resolver';
import { UserResolver } from './core/services/user.resolver';
import { WhiteLabelResolver } from './core/services/white-label.resolver';
import { EditMenuComponent } from './edit-menu/edit-menu.component';
import { NewsComponent } from './news/news.component';
import { MainContainerComponent } from './main-container/main-container.component';

const routes: Routes = [
  {
    path: 'session',
    canActivate: [SharedSessionGuard],
    component: MainContainerComponent,
  },
  {
    path: '',
    canActivate: [LanguageGuard],
    children: [
      {
        path: '',
        component: MainContainerComponent,
        resolve: {
          label: WhiteLabelResolver,
          data: UserResolver,
        },
      },
    ],
  },
  {
    path: ':lang',
    canActivate: [LanguageGuard, IEGuard],
    canActivateChild: [MobileGuard],
    resolve: {
      label: WhiteLabelResolver,
    },
    children: [
      {
        path: 'error',
        component: ErrorPageComponent,
      },
      {
        path: 'internet-explorer',
        component: InternetExplorerComponent,
      },
      {
        path: 'mobile',
        loadChildren: () => import('./mobile/mobile.module').then((m) => m.MobileModule),
      },
      {
        path: '',
        component: MainContainerComponent,
        canActivate: [UnauthorizedGuard, PaymentGuard],
        resolve: {
          label: WhiteLabelResolver,
          data: ProjectResolver,
        },
        children: [
          { path: '', component: ContainerComponent },
          {
            path: 'account',
            loadChildren: () => import('./account/account.module').then((m) => m.AccountModule),
          },
          { path: 'notifications', component: NewsComponent },
          { path: 'edit', component: EditMenuComponent },
        ],
      },
      {
        path: 'session',
        component: MainContainerComponent,
        resolve: {
          data: SharedProjectResolver,
        },
        children: [{ path: '', component: ContainerComponent }],
      },
      {
        path: 'auth',
        loadChildren: () =>
          import('./authorization/authorization.module').then((m) => m.AuthorizationModule),
      },
      {
        path: '3D',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: 'login',
        redirectTo: 'auth/login',
        pathMatch: 'full',
      },
      {
        path: 'register',
        redirectTo: 'auth/register',
        pathMatch: 'full',
      },
      {
        path: 'resetpassword',
        redirectTo: 'auth/passwordreset',
        pathMatch: 'full',
      },
      {
        path: 'removeaccount',
        redirectTo: 'auth/removeaccount',
        pathMatch: 'full',
      },
      {
        path: '**',
        component: ErrorPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
